import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Select from "@/Components/Inputs/Select";
import SelectOption from "@/Components/Inputs/SelectOption";
import { ArrowLeftIcon, ArrowRightIcon } from "@/Icons";

const range = end => {
    let newArray = [];
    for (let i = 1; end > i; i++) {
        newArray = [...newArray, i]
    }
    return newArray;
};

const Pagination = ({
    page,
    rowsPerPageOptions,
    count,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    pageSelect
}) => {
    const [selectBox, setSelectBox] = useState(rowsPerPageOptions[0]);
    const pageLimit = 4;
    const perPage = Math.ceil(count / rowsPerPage);
    const pages = range(perPage);
    const lastPage = pages[pages.length - 1];
    const startIndex = (page) * rowsPerPage + 1;
    const endIndex = Math.min(startIndex + rowsPerPage - 1, count);
    const [paginationNumbers, setPaginationNumbers] = useState([]);

    useEffect(() => {
        setSelectBox(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        const start = Math.floor(page / pageLimit) * pageLimit;

        let pageNumbers = [];
        for (let ctr = 0; ctr < pageLimit; ctr++) {
            let tempPage = start + ctr + 1;

            if (tempPage <= perPage) {
                pageNumbers.push(tempPage)
            }
            continue;
        }

        setPaginationNumbers(pageNumbers);
    }, [page, perPage, pageLimit]);

    const handleSelectChange = event => {
        setSelectBox(event.target.value);
    };

    const handleSelectChanges = event => {
        handleSelectChange(event);
        onRowsPerPageChange(event);
    };

    const handlePreviousPage = () => {
        if (page === 0) {
            return;
        }
        onPageChange(page - 1);
    };

    const handleNextPage = () => {
        if (page === lastPage || paginationNumbers?.length === 1) {
            return;
        }
        onPageChange(page + 1);
    };

    let dashMenuItems = [];
    dashMenuItems = rowsPerPageOptions.map((option, index) => {
        return (
            <SelectOption key={index} value={option}>
                {option}
            </SelectOption>
        );
    });

    return (
        <div className="pagination">
            {pageSelect && (
                <div className="pagination-page-select">
                    <span className="pagination-rows-per-page">Rows per page</span>
                    <Select
                        value={selectBox}
                        onChange={(e) => { handleSelectChanges(e) }}
                    >
                        {dashMenuItems}
                    </Select>
                </div>
            )}
            <p className="pagination-count">
                {startIndex}-{endIndex} of {count}
            </p>
            <div className="pagination-navigation">
                <button
                    disabled={page === 0}
                    onClick={handlePreviousPage}
                >
                    <ArrowLeftIcon />
                </button>

                <div className="flex mx-[12px]">
                    {paginationNumbers?.map((p, index) => (
                        p <= perPage &&
                        <button
                            key={index}
                            onClick={() => onPageChange(p - 1)}
                            className={`pagination-pagenumbers ${page === paginationNumbers[index] - 1 ? 'pagination-active' : ''}`}
                        >
                            {p.toString()}
                        </button>
                    ))}
                </div>
                <button
                    disabled={page === lastPage || paginationNumbers?.length === 1}
                    onClick={handleNextPage}
                >
                    <ArrowRightIcon />
                </button>
            </div>
        </div>
    );
};

Pagination.propTypes = {
    rowsPerPageOptions: PropTypes.array,
    pageSelect: PropTypes.bool,
};

Pagination.defaultProps = {
    pageSelect: true,
    rowsPerPageOptions: [5, 10, 15, 20],
};

export default Pagination;
